import {
  Title,
  Text,
  Space,
  Avatar,
  Button,
  Divider,
  FileButton,
  Paper,
  SimpleGrid,
  Stack,
  TextInput,
  Group,
  Select,
  NumberInput,
} from "@mantine/core";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Colors } from "../../global";

export default function Preferences() {
  return (
    <>
      <Title order={2}>Preferences</Title>
      <Text c="dimmed" size="sm">
        Change your units and other preferences.
      </Text>
      <Space h="md" />

      <Paper p="md">
        <Text size="xl">Units</Text>
        <Divider />
        <Space h="lg" />

        <SimpleGrid cols={{ sm: 1, lg: 2 }} spacing="xs" verticalSpacing="lg">
          {/* 
            https://mantine.dev/core/select
            TODO: Add logic to store temperature preferences to user account
            */}
          <Select
            label="Temperature"
            placeholder="Pick value"
            data={["°F", "°C"]}
            defaultValue="°F"
            checkIconPosition="right"
            styles={{
              input: { backgroundColor: Colors.gray100 },
            }}
          />
        </SimpleGrid>
      </Paper>

      <Space h="md" />

      <Paper p="md">
        <Group gap="xs">
          <Text size="xl" c="yellow">
            Warning
          </Text>
          <HiArrowNarrowRight size="1.5rem" />
          <Text size="xl" c="red">
            Alarm
          </Text>
          <Text size="xl">Escalation Time Interval</Text>
        </Group>
        <Divider />
        <Space h="lg" />

        <SimpleGrid cols={{ sm: 1, lg: 2 }} spacing="xs" verticalSpacing="lg">
          {/*
            Is there a max for this?
            Reference: https://mantine.dev/core/number-input/#controlled
          */}
          <NumberInput
            label="Number"
            placeholder="1"
            styles={{
              input: { backgroundColor: Colors.gray100 },
            }}
            allowDecimal={false}
            allowNegative={false}
          />

          <Select
            label="Time Units"
            placeholder="Pick Units"
            data={["Hours", "Minutes", "Seconds"]}
            defaultValue="Hours"
            checkIconPosition="right"
            styles={{
              input: { backgroundColor: Colors.gray100 },
            }}
          />
        </SimpleGrid>
      </Paper>

      <Space h="md" />

      <Paper p="md">
        <Group gap="xs">
          <Text size="xl">Theme</Text>
        </Group>
        <Divider />
        <Space h="lg" />
      </Paper>
    </>
  );
}
